import * as queries from './queries';
import app from '../../app';

export async function search({ dispatch }, searchString) {
  if (!searchString) return;

  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.searchPatients,
      variables: { searchString },
    });

    if (data && !errors) {
      return data.patientUsers.edges;
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
      });
      return [];
    }
  } catch (error) {
    dispatch('error/submit', error, { root: true });
    return [];
  }
}

export async function getAllPatients({ dispatch}) {
  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.getAllPatients,
    });

    if (data && !errors) {
      return data.patientUsers.edges;
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
      });
      return [];
    }
  } catch (error) {
    dispatch('error/submit', error, { root: true });
    return [];
  }
}

export function selectPatient({
  dispatch,
  commit,
  state,
  rootGetters,
}, selectedPatient) {
  if (state.selectedPatient.patientId !== selectedPatient.patientId) {
    commit('selectPatient', selectedPatient);

    if (selectedPatient.patientId !== rootGetters['patientSummary/id']) {
      dispatch('patientSummary/get', selectedPatient.patientId, { root: true });

      dispatch('alerts/reset', null, { root: true });
      // dispatch('alerts/getRecent', selectedPatient.patientId, { root: true });
    }
  }
}

export function reset({ commit })  {
  commit('reset');
}

export function requireReset({ commit }) {
  commit('requireReset');
}
